<template>
	<div class="d-flex flex-row align-center">
		{{ form.name }}
	</div>
	<v-alert type="warning" dense v-if="errors.id">{{ errors.id }}</v-alert>
	<v-alert type="error" dense v-if="errors.form">{{ errors.form }}</v-alert>
	<div class="d-flex flex-row align-center">
		<v-text-field
			label="熟豆重量"
			type="number"
			min="0"
			v-model.number="form.outqty"
			style="max-width: 10rem"
			:error-messages="errors.outqty"
		></v-text-field>
		克 (失重率： {{ form.lossrate }}%)
	</div>
	<div class="d-flex flex-row align-center">
		Agtron:
		<v-text-field
			label="豆色值agtron"
			v-model.number="form.agtron"
			style="max-width: 10rem; width: 10rem"
			:error-messages="errors.agtron"
		>
			<template #prepend-inner>WB</template>
		</v-text-field>
		/
		<v-text-field
			label="粉色值agtron"
			v-model.number="form.agtron_ground"
			style="max-width: 10rem; width: 10rem"
			:error-messages="errors.agtron_ground"
		>
			<template #prepend-inner>G</template>
		</v-text-field>
		（Delta: {{ agtronDelta }}）
		<v-tooltip
			text="8-12为正常范围，>14:外熟内生，<6:可能过度发展或焙焦趋势"
			:open-on-hover="false"
			target="cursor"
			location="bottom"
			open-on-click
		>
			<template v-slot:activator="{ props }">
				<iconify-icon v-bind="props" icon="mdi:information-outline"></iconify-icon>
			</template>
		</v-tooltip>
	</div>
	<div>
		烘焙度：
		<v-radio-group v-model="form.degree" inline :error-messages="errors.degree">
			<v-radio v-for="degree in refs.RoastDegree" :key="degree.value" :value="degree.value">
				<template #label>
					<roast-degree-badge
						:degree="degree.value"
						:label-override="degree.title"
						:color-override="degree.color"
					/>
				</template>
			</v-radio>
		</v-radio-group>
	</div>

	<slot name="actions" :object="form"></slot>
</template>

<script>
import { clone } from 'lodash-es'
import RoastDegreeBadge from './DegreeBadge.vue'

export default {
	components: { RoastDegreeBadge },
	props: {
		value: { type: Object, default: null },
		errors: { type: Object, default: () => ({}) }
	},
	emits: ['update:value'],
	data() {
		return {
			form: {},
			refs: {},
			syncingFromParent: false,
			lastEmitted: ''
		}
	},
	mounted() {
		this.$api.common.meta('roast', 'RoastDegree', (res) => {
			this.refs = res
		})
		this.applyValue(this.value)
	},
	computed: {
		agtronDelta() {
			const wb = Number(this.form.agtron) || 0
			const g = Number(this.form.agtron_ground) || 0
			return g - wb
		}
	},
	watch: {
		value: {
			handler(v) {
				this.applyValue(v)
			},
			deep: true
		},
		form: {
			handler(v) {
				if (this.syncingFromParent) return
				const payload = clone(v)
				const key = JSON.stringify(payload)
				if (key === this.lastEmitted) return
				this.lastEmitted = key
				this.$emit('update:value', payload)
			},
			deep: true
		},
		'form.outqty'(v) {
			if (this.syncingFromParent) return
			if (v === '' || v === null || v === undefined) {
				this.syncingFromParent = true
				this.form.outqty = 0
				this.form.lossrate = 0
				this.syncingFromParent = false
			} else if (this.form.inqty) {
				const lossrate = Number((((this.form.inqty - v) / this.form.inqty) * 100).toFixed(1))
				if (this.form.lossrate !== lossrate) {
					this.syncingFromParent = true
					this.form.lossrate = lossrate
					this.syncingFromParent = false
				}
			}
		}
	},
	methods: {
		applyValue(v) {
			if (!v) return
			this.syncingFromParent = true
			this.form = clone(v)
			this.lastEmitted = JSON.stringify(this.form)
			this.syncingFromParent = false
		}
	}
}
</script>
